import { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import PSAIModal from '@PSAIComponents/PSAIModal';
import styles from './index.module.scss';
import Iconfont from '@utils/Iconfont';
import { Input } from 'antd';
import eventBus from '../../../utils/eventBus';
import API from '@api/api'
import { message } from 'antd';



const CreateTeamModal = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        open: (obj) => handleOpen(obj),
        close: () => setCreateTeamVisible(false),
    }));


    const [createTeamVisible, setCreateTeamVisible] = useState(false);
    const [orgName, setOrgName] = useState('');
    const [loading, setLoading] = useState(false);
    const [isJump, setIsJump] = useState(true)
    const [callbackFun, setCallbackFun] = useState(null)

    useEffect(() => {
        if (!createTeamVisible) setCallbackFun(null)
    }, [createTeamVisible])

    const handleOpen = (obj) => {
        setIsJump(obj.isJump)
        setCallbackFun(() => {
            return obj.callback
        })
        setCreateTeamVisible(true)
    }

    const postSaveOrg = () => {
        if (!localStorage.getItem('token')) return
        setLoading(true)
        API.postSaveOrg({
            orgName,
        }).then((res) => {
            setLoading(false)
            if (res.code == 0) {
                if (isJump) {
                    message.success('新建企业成功，即将跳转企业账号！', 1000)
                    setTimeout(() => {
                        API.postChangeOrg({
                            orgId: res.data.id
                        }).then((res) => {
                            if (res.code == 0) window.location.reload()
                        })
                    }, 1500)
                } else {
                    message.success('新建企业成功！')
                    callbackFun?.(res.data.id)
                }
                setCreateTeamVisible(false)
                eventBus.emit('getUserOrgInfo')
            }
        })
    }

    const onClickOk = () => {
        if (!orgName) return
        postSaveOrg()
    }


    return <>
        <PSAIModal
            title='新建企业'
            maxWidth={400}
            okText={'确定'}
            open={createTeamVisible}
            maskClosable={false}
            okButtonProps={{ disabled: false, loading: loading }}
            onCancel={() => setCreateTeamVisible(false)}
            onOk={onClickOk}
            zIndex={1002}
        >
            <div className={styles.createTeamWrap}>
                <Input
                    size="large"
                    onChange={(e) => setOrgName(e.target.value)}
                    maxLength={20}
                    placeholder='请输入企业名称'
                    suffix={`${orgName.length}/20`}
                    prefix={<Iconfont className={styles.Icon} type="icon-reuseOutlined" />} />
                <p>• 新建的企业拥有新的独立空间，将无法同步您已有的企业数据</p>
                <p>• 如需继续使用已有企业的数据，请切换至对应企业进行付费使用</p>
            </div>
        </PSAIModal>
    </>
})
export default CreateTeamModal
